var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"herobanner-controller"},[_c(_vm.heroType,_vm._b({tag:"component"},'component',_vm.heroBannerProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }